<template>
  <div style="min-height: 90vh">
    <v-layout wrap justify-center>
      <v-flex xs12>
        <!-- <v-img height="250px" cover :src="require('./../../assets/images/Asset2.jpg')"> -->
        <v-container>
          <v-layout wrap py-8 py>
            <v-flex xs12 sm4 py-3 align-self-center text-center class="about1">
              About Us
            </v-flex>
            <v-flex sm8 align-self-center text-justify class="title11">
              The kingdom of “Shere Khan” the infamous tiger which wanted to
              keep the human cub out of his forest is shrinking and ironically,
              the much-hated Shere Khan was right and may be a visionary in his
              own rights! He had foreseen that a human inside his forest, is not
              good for him as well as for Bagheera and even the pack of wolves
              with whom Sherkhan always had a fight. He followed the rule of the
              jungle, which humanity is now trying to understand so that the
              wilderness survives to save and secure the planet for the future.
            </v-flex>
          </v-layout>
        </v-container>
        <!-- </v-img> -->
      </v-flex>
      <v-flex xs12 align-self-center>
        <v-layout wrap justify-center>
          <v-flex md6 align-self-center>
            <v-card
              :style="
                $vuetify.breakpoint.name == 'sm'
                  ? 'height :370px'
                  : $vuetify.breakpoint.name == 'xs'
                  ? 'height :820px'
                  : $vuetify.breakpoint.name == 'md'
                  ? 'height :500px'
                  : $vuetify.breakpoint.name == 'xl'
                  ? 'height :800px'
                  : 'height :500px'
              "
              color="#F6A448"
              tile
            >
              <v-layout wrap justify-center pa-12 pa-md-8 pa-lg-12>
                <v-flex xs12 md12 lg10 align-self-center text-justify>
                  <span class="title15">
                    Tiger Crimes are reported from across the world, but there
                    are no central global platforms where such information is
                    gathered or shared. As a result, we often miss the larger
                    picture and reality. The Tigerthon is an initiative to
                    develop a global platform to collect information about tiger
                    related crimes from all over the world, through volunteers,
                    specially designed search bots to monitor the digital world
                    and from those who would like to share some intelligence
                    about criminal activities.
                  </span>
                  <br />
                  <br />
                  <span class="title15">
                    <b> Result:</b>
                    <br />
                    With the Tigerthon, we propose to develop the global
                    platform to collect, analyze and share information as well
                    as intelligence related to incidents involving tigers across
                    the globe.
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex md6 align-self-center>
            <v-card
              flat
              :style="
                $vuetify.breakpoint.name == 'sm'
                  ? 'height :340px'
                  : $vuetify.breakpoint.name == 'xs'
                  ? 'height :590px'
                  : $vuetify.breakpoint.name == 'md'
                  ? 'height :500px'
                  : $vuetify.breakpoint.name == 'xl'
                  ? 'height :800px'
                  : 'height :500px'
              "
              color="transparent"
              tile
            >
              <v-layout wrap justify-center pa-12 pa-md-8 pa-lg-12>
                <v-flex xs12 md12 lg10 align-self-center text-justify>
                  <span class="title11">
                    Today, the number of tigers in the wild has reduced and
                    their habitat has dwindled too. Some species of tigers have
                    got wiped out and some species remain only in few numbers.
                    The presence of the tiger in the forest is the sign of a
                    perfect ecosystem, whether it is the Snow covered Siberian,
                    the semi-arid forests of Ranthambore or in the tropical
                    evergreen forests of Silent Valley in Southern India. Tigers
                    are the icons of conservation, and they need to be there in
                    the forests, to ensure the future of the ecosystem.
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 lg8 pa-9 pa-sm-16 align-self-center>
        <v-layout wrap justify-center py-10>
          <v-flex
            xs6
            sm3
            lg3
            align-self-center
            v-for="(item, i) in partners"
            :key="i"
          >
            <v-img
              contain
              :height="i==0?'50px':'70px'"
              :width="
                $vuetify.breakpoint.name == 'xs' ||
                $vuetify.breakpoint.name == 'sm'
                  ? '210px'
                  : '200px'
              "
              :src="item.link"
            ></v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partners: [
        { link: require("./../../assets/images/YOTI_Logo.png") },
        { link: require("./../../assets/images/BrightTideLogo.png") },
        { link: require("./../../assets/images/WTILogoHR.png") },
        { link: require("./../../assets/images/LeopardLogo.png") },
      ],
    };
  },
};
</script>
<style scoped>
</style>